import {
  QuoteHashStatus,
  QuoteStatusByUserType,
  SubStatus,
} from '../../modules/quotes/quote.service.interface';

export const quoteParams = ['h', 'x'];

export type UtmParams = {
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_content: string;
  utm_term: string;
  utm_transaction: string;
  utm_customer: string;
};

export const PERMISSIONS_OMITTING_FIELDS: object = {
  'QUOTE.ENTITY.SHOW_COMMISSION': [
    'order.agentCommissionValue',
    'order.agentCommissionOfferedEarned',
    'order.agentCommissionOfferedValue',
    'order.formatted.agentCommissionOfferedEarned',
    'order.formatted.agentCommissionValue',
    'order.formatted.agentCommissionOfferedValue',
  ],
};

export const quoteHashStatuses: string[] = [
  'created',
  'sent',
  'clicked',
  'paid',
  'revoked',
];

export type QuoteHashStatuses =
  | 'created'
  | 'sent'
  | 'clicked'
  | 'paid'
  | 'revoked';

export const quoteStatus: string[] = [
  'in_progress',
  'paid',
  'issued',
  'refunded',
  'archived',
  'canceled',
];

export type QuoteStatus =
  | 'in_progress'
  | 'paid'
  | 'issued'
  | 'refunded'
  | 'archived'
  | 'canceled';

export const quoteSubStatus: string[] = [
  '',
  'pending_quotation',
  'pending_product_selection',
  'pending_payment_details',
  'pending_customer_payment',
  'pending_customer_details',
  'pending_quotation',
  'pending_details',
  'invited',
  'invite_opened',
  'plan_selected',
];

export type QuoteSubStatus =
  | ''
  | 'pending_quotation'
  | 'pending_product_selection'
  | 'pending_payment_details'
  | 'pending_customer_payment'
  | 'pending_quotation'
  | 'pending_customer_details'
  | 'invite_sent'
  | 'quote_viewed'
  | 'plan_selected';

export const STATUS: QuoteStatusByUserType = {
  IN_PROGRESS: 'in_progress',
  PAID: 'paid',
  ISSUED: 'issued',
  REFUNDED: 'refunded',
  ARCHIVED: 'archived',
  CANCELED: 'canceled',
};

export const SUBSTATUS: SubStatus = {
  LICENSED: {
    PENDING_QUOTATION: 'pending_quotation',
    PENDING_PRODUCT_SELECTION: 'pending_product_selection',
    PENDING_PAYMENT_DETAILS: 'pending_payment_details',
    PENDING_CUSTOMER_PAYMENT: 'pending_customer_payment',
  },
  UNLICENSED: {
    PENDING_QUOTATION: 'pending_quotation',
    PENDING_CUSTOMER_DETAILS: 'pending_customer_details',
    INVITE_SENT: 'invite_sent',
    QUOTE_VIEWED: 'quote_viewed',
    PLAN_SELECTED: 'plan_selected',
  },
};

export const QUOTEHASH_STATUS: QuoteHashStatus = {
  CREATED: 'created',
  SENT: 'sent',
  CLICKED: 'clicked',
  PAID: 'paid',
  REVOKED: 'revoked',
};

export const crmStatusReason: number[] = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,
];

export type CrmStatusReason = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export const pickFieldsOnPaymentConfirmed: string[] = [
  'policyIssued',
  'policies',
  'policiesStatus',
  'status',
  'substatus',
  'order',
  'scoreForm',
];

export enum Option {
  YES = 'Y',
  NO = 'N',
}
